import React from 'react';
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom'


const MetaData = () => {
  const { t } = useTranslation();
  let location = useLocation();

  let page = location.pathname.substring(1);
  page = page.charAt(0).toUpperCase() + page.slice(1)

  return (
    <Helmet>
      <title>{page.length>0 ? `${page} | ${t("title")}` : t("title")}</title>
    </Helmet>
  )
}

export default MetaData
